<template>
  <span class="green--text">{{ split2(title, ' ')[0] }}<span class="pink--text ml-2 ">{{ split2(title, ' ')[1] }}</span>
  </span>
</template>

<script>
export default {
  name: "themedTitle",
  props: {
    title: {
      type: String,
      required:true
    }
  }
}
</script>

<style scoped>

</style>